import React, { useEffect } from 'react';
import ExpiredOrderModal from '../../../../components/Purchase/ExpiredOrderModal';
import { useHistory } from 'react-router-dom';
import { useCheckoutMvp } from './hooks/useCheckoutMvp';
import { useDispatch } from 'react-redux';
import { cleanOrderSimulate } from '../../../../store/ducks/order-simulate-checkout-mvp/actions';
import { ERoutes } from '../../../../routes';
import { EPurchaseRoutes } from '../../purchase.routes';
import { useCartService } from '../../../../services/MVP/useCartService';

const ExpiredOrder = () => {
  const history = useHistory();
  const { deleteCartId } = useCheckoutMvp();
  const { handleUpdateQuantity } = useCartService();
  const dispatch = useDispatch();

  useEffect(() => {
    deleteCartId();
  }, []);

  const toCleanOrderSimulate = () => {
    handleUpdateQuantity(0);
    dispatch(cleanOrderSimulate());
  };

  const onBackOnClick = () => {
    history.push(ERoutes.DASHBOARD);
    toCleanOrderSimulate();
  };

  const onContinueOnClick = () => {
    history.push(
      `${ERoutes.PURCHASE}/${EPurchaseRoutes.COMMERCE}/${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`
    );
    toCleanOrderSimulate();
  };

  return (
    <ExpiredOrderModal
      onBackClick={onBackOnClick}
      onStartClick={onContinueOnClick}
    />
  );
};

export default ExpiredOrder;
